exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table th[data-v-27229ea4] {\n  text-align: left;\n  padding-left: 4rem !important;\n}\ntable td[data-v-27229ea4] {\n  text-align: left;\n  padding-left: 2rem !important;\n}", ""]);

// exports
